import React from "react";
import { Calendar } from "lucide-react";

// Parse a YYYY, YYYY-MM, or YYYY-MM-DD style date string into a sortable numeric value.
// Non-numeric or "Ongoing" entries sort to the top (treated as current).
function dateKey(d) {
    if (!d) return 99999999;
    const s = String(d).toLowerCase();
    if (s.includes("ongoing") || s.includes("present") || s.includes("current")) return 99999999;
    const m = s.match(/(\d{4})(?:-(\d{1,2}))?(?:-(\d{1,2}))?/);
    if (!m) return 0;
    const y = parseInt(m[1], 10);
    const mo = m[2] ? parseInt(m[2], 10) : 12;
    const da = m[3] ? parseInt(m[3], 10) : 28;
    return y * 10000 + mo * 100 + da;
}

export default function Timeline({ items }) {
    if (!items || items.length === 0) return null;
    // Display newest → oldest (reverse chronological) for an investigative feel.
    const sorted = [...items].sort((a, b) => dateKey(b.date) - dateKey(a.date));
    return (
        <div className="relative">
            <div className="absolute left-3.5 top-2 bottom-2 w-px bg-[#243044]" />
            <div className="space-y-6">
                {sorted.map((item, i) => (
                    <div key={item.id || i} className="relative pl-12" data-testid={`timeline-item-${i}`}>
                        <div className="absolute left-0 top-1 w-7 h-7 rounded-full bg-[#0B1220] border-2 border-[#2F80ED] flex items-center justify-center">
                            <Calendar className="w-3 h-3 text-[#56CCF2]" />
                        </div>
                        <div className="bg-[#111827] border border-[#243044] rounded-xl p-5 hover:border-[#2F80ED]/40 transition-colors">
                            {item.date && (
                                <div className="text-[10px] uppercase tracking-[0.2em] text-[#56CCF2] font-medium mb-2">
                                    {item.date}
                                </div>
                            )}
                            <h4 className="text-sm font-semibold text-white mb-2">{item.title}</h4>
                            {item.description && (
                                <p className="text-sm text-[#94A3B8] leading-relaxed">{item.description}</p>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
